import type { FormSubmissionAnswer, PortalFormRequest, PortalFormRequestStatus } from '~/types/models';

export function isOpenPortalFormRequest(status?: PortalFormRequestStatus | null): boolean {
    return status === 'pending' || status === 'in_progress';
}

export function isInProgressPortalFormRequest(request?: Partial<PortalFormRequest> | null): boolean {
    return request?.status === 'in_progress' && Array.isArray(request.draftAnswers);
}

export function refreshedPortalFormRequestStatus(
    status?: PortalFormRequestStatus | null,
): Extract<PortalFormRequestStatus, 'pending' | 'in_progress'> {
    return status === 'in_progress' ? 'in_progress' : 'pending';
}

export function resolvePortalFormDraftAnswers(
    request: Partial<PortalFormRequest> | null | undefined,
    localAnswers: FormSubmissionAnswer[],
): FormSubmissionAnswer[] {
    const hasServerDraft = request?.status === 'in_progress'
        || Boolean(request?.draftUpdatedAt)
        || Boolean(request?.startedAt);

    if (hasServerDraft) {
        return Array.isArray(request?.draftAnswers) ? request.draftAnswers : [];
    }

    return localAnswers;
}
